<template>
  <div></div>
</template>
<script>
import EventBus from "../service/EventBus";

export default {
  methods: {
    checkTypeNoti(dataNoti) {
      if (
        !dataNoti ||
        (dataNoti && !dataNoti.data) ||
        (dataNoti && dataNoti.data && !dataNoti.data.type)
      ) {
        this.$notify.closeAll();
        return;
      }
      if (["DOC_REQUEST_FOR_SIGN_AGAIN", "DOC_REQUEST_FOR_DFAFF_SIGN_AGAIN"].includes(dataNoti.data.type)) {
        window.toastr.info((dataNoti.notification && dataNoti.notification.body) || "Bạn đã được rút khỏi danh sách ký của văn bản này.");
        this.$notify.closeAll();
        return;
      }
      if (
        dataNoti.data.type == "LUNCH_REGISTRATION_WEEKLY_REMINDER" ||
        dataNoti.data.type == "LUNCH_REGISTRATION_DAILY_REMINDER"
      ) {
        this.$router
          .push({
            name: "Admin-LunchRegistration",
            query: { weekStart: dataNoti.data.id },
          })
          .catch((err) => {});
      }
      // News module
      else if (
        dataNoti.data.type == "APPROVERED_NEWS" ||
        dataNoti.data.type == "NEWS" ||
        dataNoti.data.type == "REQUEST_APPROVEL_NEWS"
      ) {
        this.$router
          .push({
            name: "Admin-News-detail",
            params: { id: dataNoti.data.id },
          })
          .catch((err) => {});
      } else if (dataNoti.data.type == "REQUEST_EDIT_NEWS") {
        this.$router
          .push({
            name: "Admin-News-update",
            params: { id: dataNoti.data.id },
          })
          .catch((err) => {});
      }
      // Employee Detail
      else if (dataNoti.data.type == "WAITING_FOR_APPROVAL_SALARY") {
        this.$router
          .push({
            name: "Admin-Salary-SalaryPeriod-SalaryPeriodList-detail",
            params: { id: dataNoti.data.id },
          })
          .catch((err) => {});
      } else if (
        dataNoti.data.type == "APPROVERED_EMPLOYEE_DRAFT" ||
        dataNoti.data.type == "REJECT_EMPLOYEE_DRAFT"
      ) {
        this.$router
          .push({
            name: "Admin-EmployeeInfo-detail",
            params: { id: dataNoti.data.id },
          })
          .catch((err) => {});
      } else if (
        dataNoti.data.type == "CREATED_EMPLOYEE_DRAFT" ||
        dataNoti.data.type == "UPDATED_EMPLOYEE_DRAFT"
      ) {
        this.$router
          .push({
            name: "Admin-EmployeeManager-approve",
            params: { id: dataNoti.data.id },
          })
          .catch((err) => {});
      }
      // Document module
      else if (
        dataNoti.data.type == "DOC_REQUEST_FOR_SIGN" ||
        dataNoti.data.type == "DOC_REQUEST_FOR_SIGN_AGAIN"
      ) {
        this.$router
          .push({
            name: "Admin-ElectronicDocument-detail",
            params: { id: dataNoti.data.id },
            query: {
              type: "DOC_SIGN_CONSENT",
            },
          })
          .catch((err) => {});
      } else if (
        dataNoti.data.type == "DOC_PUBLISHED" ||
        dataNoti.data.type == "DOC_TRANSFER"
      ) {
        this.$router
          .push({
            name: "Admin-ElectronicDocument-detail",
            params: { id: dataNoti.data.id },
            query: {
              type: "DOC_IN",
            },
          })
          .catch((err) => {});
      } else if (
        dataNoti.data.type == "DOC_REQUEST_FOR_DFAFF_SIGN" ||
        dataNoti.data.type == "DOC_REQUEST_FOR_DFAFF_SIGN_AGAIN"
      ) {
        this.$router
          .push({
            name: "Admin-ElectronicDocument-detail",
            params: { id: dataNoti.data.id },
            query: {
              type: "DOC_SIGN_TEMP",
            },
          })
          .catch((err) => {});
      } else if (dataNoti.data.type == "DOC_SIGNED") {
        this.$router
          .push({
            name: "Admin-ElectronicDocument-detail",
            params: { id: dataNoti.data.id },
            query: {
              type: "DOC_OUT",
            },
          })
          .catch((err) => {});
      } else if (
        dataNoti.data.type == "DOC_REJECTED" ||
        dataNoti.data.type == "DOC_RECALLED"
      ) {
        this.$router
          .push({
            name: "Admin-ElectronicDocument-detail",
            params: { id: dataNoti.data.id },
            query: {
              type: "DOC_SIGN",
            },
          })
          .catch((err) => {});
      }
      // Salary module
      else if (dataNoti.data.type == "NOTIFICATION_SALARY") {
        this.$router
          .push({
            name: "Admin-SalaryEmployee-list",
          })
          .catch((err) => {});
      } else if (
        dataNoti.data.type == "APPROVED_SALARY" ||
        dataNoti.data.type == "REJECTED_SALARY"
      ) {
        this.$router
          .push({
            name: "Admin-Salary-SalaryPeriod-SalaryPeriodList-detail",
            params: { id: dataNoti.data.id },
          })
          .catch((err) => {});
      }
      // HDDT
      else if (
        dataNoti.data.type == "SIGN_REJECTED_DOCUMENT_AUTO" ||
        dataNoti.data.type == "SIGN_REQUEST_DOCUMENT_AUTO" ||
        dataNoti.data.type == "SIGN_APPROVED_DOCUMENT_AUTO"
      ) {
        this.$router
          .push({
            name: "Admin-DocumentDrafting-sign-approve",
            params: { id: dataNoti.data.id },
          })
          .catch((err) => {});
      }
      // Chốt công
      else if (
        dataNoti.data.type == "APPROVED_WORK_A_DAY" ||
        dataNoti.data.type == "APPROVED_WORK_A_MONTH"
      ) {
        this.$router
          .push({
            name: "Admin-Timekeeping-Employee-EmployeeWorksheet",
            query: { salaryPeriodId: dataNoti.data.id },
          })
          .catch((err) => {});
      }
      // Request
      else if (
        dataNoti.data.type == "DAY_OFF" ||
        dataNoti.data.type == "GO_LATE" ||
        dataNoti.data.type == "COME_BACK_SOON" ||
        dataNoti.data.type == "WORK_EXPLANATION" ||
        dataNoti.data.type == "GO_OUT" ||
        dataNoti.data.type == "GO_ON_BUSSINESS" ||
        dataNoti.data.type == "TIME_KEEPING_ONLINE" ||
        dataNoti.data.type == "OT"
      ) {
        this.$router
          .push({
            name: "Admin-ManageRequests-CheckRequest",
            params: { id: dataNoti.data.id },
          })
          .catch((err) => {});
      }

      this.$notify.closeAll();
    },

    openNoti(dataNoti) {
      this.$notify.warning({
        title: `${
          dataNoti.notification && dataNoti.notification.title
            ? dataNoti.notification.title
            : "Thông báo"
        }`,
        message: `${
          dataNoti.notification && dataNoti.notification.body
            ? dataNoti.notification.body
            : "Nội dung"
        }`,
        position: "bottom-right",
        duration: 0.5 * 1000 * 60,
        // duration: 0,
        customClass: "noti-firebase",
        onClick: () => {
          this.checkTypeNoti(dataNoti);
        },
      });
    },
  },

  created() {
    EventBus.$on("receivedOnMessage", this.openNoti);
  },

  destroyed() {
    EventBus.$off("receivedOnMessage", this.openNoti);
  },
};
</script>
<style lang="scss">
.el-notification.noti-firebase {
  background: antiquewhite;
  cursor: pointer;
}
</style>
